import { render, staticRenderFns } from "./DealersDashboard.vue?vue&type=template&id=a90606f0&"
import script from "./DealersDashboard.vue?vue&type=script&lang=js&"
export * from "./DealersDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports